export const rootElementId = 'premium-landing-page';

export const translationConfig = {
  common: [],
  feature: 'Feature.Premium'
};
